import { Menu, MenuContent, MenuTrigger, MenuItem, Button } from '@cad-arc';

interface ExportButtonProps {
    hasAttachments: boolean;
    isLoading: boolean;
    onExportPDF: () => void;
    onExportPDFWithAttachments: () => void;
}

export function ExportButton({
    hasAttachments,
    isLoading,
    onExportPDF,
    onExportPDFWithAttachments,
}: ExportButtonProps) {

    // isModal is required on this button so the panel properly receives focus when the menu is clicked if it is not the currently focused panel.
    // Ideally it would get focus on mouse down like other buttons, but for now it only focuses on menu item select.  Adding the isModal prop also
    // fixes an issue where the menu item would not run its onclick for some reason.
    return hasAttachments ? (
        <Menu isModal>
            <MenuTrigger asChild>
                <Button
                    aria-label="Export options"
                    variant="outline"
                    isLoading={isLoading}
                    rightIcon="TriangleDown"
                    data-testid="export-pdf-menu-trigger"
                >
                    Export
                </Button>
            </MenuTrigger>
            <MenuContent>
                <MenuItem
                    aria-label="Export to PDF"
                    onSelect={onExportPDF}
                    data-testid="export-pdf-menu-item"
                >
                    PDF
                </MenuItem>
                <MenuItem
                    aria-label="Export to PDF with attachments"
                    onSelect={onExportPDFWithAttachments}
                    data-testid="export-pdf-with-attachments-menu-item"
                >
                    PDF with attachments
                </MenuItem>
            </MenuContent>
        </Menu>
    ) : (
        <Button
            aria-label="Export to PDF"
            variant="outline"
            isLoading={isLoading}
            onClick={onExportPDF}
            data-testid="export-pdf-button"
        >
            Export
        </Button>
    );
}
